import { QuestionRuleInstance } from '@jupiterone/jupiter-types';
import { useValidation } from '@jupiterone/jupiter-web-toolkit';
import * as validationFunctions from './utils/ruleValidators';

const useRuleValidation = (rule: Partial<QuestionRuleInstance>) => {
  const name = useValidation(rule.name, validationFunctions.nameIsNotEmpty);
  const templates = useValidation(
    rule.templates,
    validationFunctions.hasNoEmptyTemplateFields
  );
  return { hasErrors: name.error || templates.error, name, templates };
};

export default useRuleValidation;
